<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Acknowledgments-rw exclude-auto-rw page-open-right-rw" epub:type="frontmatter acknowledgments" id="Acknowledgements1">
<div class="title-block-rw" id="title-block5">
<h1 id="h15"><a href="#/Text/TOC">Acknowledgments</a></h1>
</div>
<p class="firstpara-rw" id="p40">I am forever grateful to Stephany Evans—the first person to believe in me—and to my editor, Madeleine Colavita, who has helped me grow as a writer with each book. A big thank you once again to Ray and Brijet Whitney for their hockey research help. You guys are wonderful. My family continues to be my greatest support system and I couldn’t do this without them—Reagan and Jacob, I love you! And a big hug to my readers of this series who love the Westmores as much as I do—especially Becca Johnson, who shared her family’s Christmas candy recipe with me. It is now a Westmore tradition.</p>
<p class="signature-fm-rw" id="signature1">XO,</p>
<p class="signature-continued-fm-rw" id="signature2">Jen</p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s005-Acknowledgments-01.vue?44b3394e